import { Check, Globe, ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { scrollToSection } from "@/lib/scroll";

const FEATURES = [
  "Custom-styled 1 to 5-page website",
  "Hosting, SSL, and backups included",
  "Basic SEO foundations",
  "Ongoing maintenance and security updates",
  "Monthly support allowance",
];

const TERMS = [
  "From £49 per month",
  "12-month minimum term",
  "Rolling monthly after the initial term",
];

export const ManagedWebsites = () => {
  const enquire = () => {
    window.dispatchEvent(
      new CustomEvent("prefill-interest", {
        detail: "Website from £49/month",
      })
    );
    scrollToSection("contact");
  };

  return (
    <section
      id="managed-websites"
      data-testid="managed-websites-section"
      className="py-20 md:py-28 bg-white"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10 lg:px-16">
        <div className="rounded-3xl border border-slate-200 bg-slate-50 p-8 md:p-12 lg:p-14">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
            <div className="lg:col-span-6">
              <Reveal>
                <div className="flex items-center gap-2">
                  <span className="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-brand-blue/10 text-brand-blue">
                    <Globe className="h-5 w-5" strokeWidth={2} />
                  </span>
                  <p className="text-xs font-semibold tracking-[0.2em] uppercase text-brand-blue">
                    Managed websites
                  </p>
                </div>
                <h2 className="mt-5 font-heading font-700 text-3xl sm:text-4xl tracking-tight text-brand-navy">
                  Professional business websites from £49 per month
                </h2>
                <p className="mt-5 text-lg leading-relaxed text-slate-600">
                  We also offer fully managed websites for local service
                  businesses that need a professional online presence without
                  the cost and hassle of building and maintaining it themselves.
                </p>
                <p className="mt-4 leading-relaxed text-slate-600">
                  A simple monthly package designed for businesses that want a
                  polished website and dependable support without a large
                  upfront build cost.
                </p>

                <div className="mt-7 flex flex-wrap gap-2">
                  {TERMS.map((t) => (
                    <span
                      key={t}
                      data-testid={`managed-term-${t.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                      className="rounded-full border border-slate-200 bg-white px-3.5 py-1.5 text-xs font-medium text-slate-600"
                    >
                      {t}
                    </span>
                  ))}
                </div>

                <button
                  data-testid="managed-websites-cta"
                  onClick={enquire}
                  className="mt-8 inline-flex items-center gap-2 bg-brand-navy text-white font-medium px-6 py-3.5 rounded-lg hover:bg-brand-navy-dark transition-colors"
                >
                  Enquire using the contact form
                  <ArrowRight className="h-4 w-4" strokeWidth={2} />
                </button>
              </Reveal>
            </div>

            <div className="lg:col-span-6 lg:pl-8 lg:border-l lg:border-slate-200">
              <Reveal delay={0.1}>
                <p className="text-sm font-semibold text-brand-navy">
                  What's included
                </p>
                <ul className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-4">
                  {FEATURES.map((f, i) => (
                    <li
                      key={f}
                      data-testid={`managed-feature-${i}`}
                      className="flex items-start gap-3"
                    >
                      <span className="mt-0.5 inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-brand-blue/10 text-brand-blue">
                        <Check className="h-4 w-4" strokeWidth={2.5} />
                      </span>
                      <span className="text-sm leading-relaxed text-slate-700">
                        {f}
                      </span>
                    </li>
                  ))}
                </ul>
              </Reveal>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
